// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExpenseReportDetail  {
    _originalTypeClassName = "Loom.BO.ExpenseReportDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExpenseReportDetail.translate = translateService;
}
this.Attachments = [];
this.Id = null;
this.IssueDate = null;
this.Title = null;
this.Description = null;
this.NetAmountEUR = null;
this.AmountEUR = null;
this.AmountInLocalCurrency = null;
this.ExchangeRate = null;
this.PaidByTheCompany = false;
this.Reimbursable = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IssueDate:any;
Title:any;
Description:any;
NetAmountEUR:any;
AmountEUR:any;
AmountInLocalCurrency:any;
ExchangeRate:any;
PaidByTheCompany:any;
Reimbursable:any;
ExpenseReport:any;
Category:any;
ReceiptImage:any;
OtherCurrency:any;
Attachments:any;
static setExpenseReport = ($this, value) => {
var oldValue = $this.ExpenseReport;
$this.ExpenseReport = value;
if (value != null) {
if (oldValue != null) {
Domain.ExpenseReport.removeExpenses(oldValue, $this);
}
Domain.ExpenseReport.addExpenses(value, $this);
}
}
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}
static setReceiptImage = ($this, value) => {
var oldValue = $this.ReceiptImage;
$this.ReceiptImage = value;
if (value != null) {
}
}
static setOtherCurrency = ($this, value) => {
var oldValue = $this.OtherCurrency;
$this.OtherCurrency = value;
if (value != null) {
}
}
static setAttachments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attachments == null) $this.Attachments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attachments.length > 0) {
                    Domain.ExpenseReportDetail.removeAttachments($this, $this.Attachments[0]);
                }

                Domain.ExpenseReportDetail.addManyAttachments($this, copyItems);
            }
static addManyAttachments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExpenseReportDetail.addAttachments($this, items[i]);
                }
            }
static addAttachments = ($this, item) => {
                if ($this.Attachments == null) $this.Attachments = [];
                if (item == null || $this.Attachments.indexOf(item) > -1) return;
                $this.Attachments.push(item);
}
static addRangeAttachments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExpenseReportDetail.addAttachments($this, item));
            }
static removeAttachments = ($this, item) => {
                if ($this == null || $this.Attachments == null || $this.Attachments.indexOf(item) === -1) return;
                var _index = $this.Attachments.indexOf(item);
                $this.Attachments.splice(_index, 1);
}
static clearAttachments = ($this) => { $this.Attachments = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}